import { Button } from 'blaze-ui/Button'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'
import { ColorSwatch2 } from 'blaze-ui/icons'
import {
  CloudinaryEffectItem,
  CloudinaryEffectMenu,
} from 'common/Prose/nodeViews/Image/components/FormatBar/CloudinaryEffectMenu/CloudinaryEffectMenu'

interface Props {
  attrs: ImageNodeAttrs
  onAdjust: () => void
}

export const ColorMenu = ({ attrs, onAdjust }: Props) => {
  return (
    <MenuTrigger>
      <Button frontIcon={ColorSwatch2} variant="tertiary" rounded size="xs">
        Color
      </Button>
      <CloudinaryEffectMenu aria-label="Color" attrs={attrs} onEffect={onAdjust}>
        <CloudinaryEffectItem key="red:0">Hue</CloudinaryEffectItem>
        <CloudinaryEffectItem key="saturation:0">Saturation</CloudinaryEffectItem>
      </CloudinaryEffectMenu>
    </MenuTrigger>
  )
}
